/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIProductionWithdrawal
 */
export interface APIProductionWithdrawal {
    /**
     * 
     * @type {string}
     * @memberof APIProductionWithdrawal
     */
    readonly self: string;
    /**
     * 
     * @type {number}
     * @memberof APIProductionWithdrawal
     */
    readonly id: number;
    /**
     * 
     * @type {Date}
     * @memberof APIProductionWithdrawal
     */
    timestamp: Date;
    /**
     * 
     * @type {number}
     * @memberof APIProductionWithdrawal
     */
    amount: number;
}

/**
 * Check if a given object implements the APIProductionWithdrawal interface.
 */
export function instanceOfAPIProductionWithdrawal(value: object): value is APIProductionWithdrawal {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function APIProductionWithdrawalFromJSON(json: any): APIProductionWithdrawal {
    return APIProductionWithdrawalFromJSONTyped(json, false);
}

export function APIProductionWithdrawalFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIProductionWithdrawal {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'id': json['id'],
        'timestamp': (new Date(json['timestamp'])),
        'amount': json['amount'],
    };
}

export function APIProductionWithdrawalToJSON(value?: Omit<APIProductionWithdrawal, 'self'|'id'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'timestamp': ((value['timestamp']).toISOString()),
        'amount': value['amount'],
    };
}

